import React from "react";
import { useState } from "react";
import Styles from "../../Styles/Resume.module.css"
import { Button } from "@mui/material";
import add from "../../Assets/add.png";


const SKills = () => {
    const [workSkill, setWorkSkill] = useState([
      {
        skill1: 'React',
        skill2: 'Javascript',
        skill3: 'Phyton',
        skill4: 'Html',
        skill5: 'CSS',
        skill6: 'PHP',
        skill7: 'Next',
        skill8: 'Redux',
        skill9: 'Vue',
        skill10: 'Angular',
        
      },
    ]);
  
    const [newWorkSkill, setNewWorkSkill] = useState({
        skill1: '',
        skill2: '',
        skill3: '',
        skill4: '',
        skill5: '',
        skill6: '',
        skill7: '',
        skill8: '',
        skill9: '',
        skill10: '',

    });
  
    const handleAddWorkSkill = () => {
      setWorkSkill([...workSkill, newWorkSkill]);
      setNewWorkSkill({
        skill1: '',
        skill2: '',
        skill3: '',
        skill4: '',
        skill5: '',
        skill6: '',
        skill7: '',
        skill8: '',
        skill9: '',
        skill10: '',
       
      });
    };
  
  
    const handleDeleteWorkSkill = (index) => {
      const updatedWorkSkill = [...workSkill];
      updatedWorkSkill.splice(index, 1);
      setWorkSkill(updatedWorkSkill);
    };

    const [modalOpen,  setModalOpen  ] = useState(false)

    const handleCloseModal = () => {
      setModalOpen(false);
    };
   
   
  
    return (
        <div className={Styles.contents4}>
    {workSkill.map((skill, index) => (    
        <><div key={index} className={Styles.subcontent}>
            <div className={Styles.subcontent1}>
                <h1>Skills</h1>
            </div>
            <div className={Styles.subcontent2}>
                <img src={add} alt="/" onClick={() => setModalOpen(true)} width="23.0px" height="23.0px" />
            </div>
        </div><div className={Styles.subcontent01}>
                <hr style={{ width: "605px" }}></hr>
            </div><div className={Styles.subcontent02}>
                <div className={Styles.subcontent1}>
                    <Button sx={{ width: "115.42px", height: "38.84px", borderRadius: "13.38px", backgroundColor: "rgba(243, 114, 63, 1)", color: "#fff", "&:hover": { backgroundColor: "rgba(243, 114, 63, 1)" } }}  onClick={() => handleDeleteWorkSkill(index)} >{skill.skill1}</Button>
                    <Button sx={{ width: "115.42px", height: "38.84px", borderRadius: "13.38px", backgroundColor: "rgba(243, 114, 63, 1)", color: "#fff", "&:hover": { backgroundColor: "rgba(243, 114, 63, 1)" } }}>{skill.skill2}</Button>
                    <Button sx={{ width: "115.42px", height: "38.84px", borderRadius: "13.38px", backgroundColor: "rgba(243, 114, 63, 1)", color: "#fff", "&:hover": { backgroundColor: "rgba(243, 114, 63, 1)" } }}>{skill.skill3}</Button>
                    <Button sx={{ width: "115.42px", height: "38.84px", borderRadius: "13.38px", backgroundColor: "rgba(243, 114, 63, 1)", color: "#fff", "&:hover": { backgroundColor: "rgba(243, 114, 63, 1)" } }}>{skill.skill4}</Button>
                    <Button sx={{ width: "115.42px", height: "38.84px", borderRadius: "13.38px", backgroundColor: "rgba(243, 114, 63, 1)", color: "#fff", "&:hover": { backgroundColor: "rgba(243, 114, 63, 1)" } }}>{skill.skill5}</Button>
                    <Button sx={{ width: "115.42px", height: "38.84px", borderRadius: "13.38px", backgroundColor: "rgba(243, 114, 63, 1)", color: "#fff", "&:hover": { backgroundColor: "rgba(243, 114, 63, 1)" } }}>{skill.skill6}</Button>
                    <Button sx={{ width: "115.42px", height: "38.84px", borderRadius: "13.38px", backgroundColor: "rgba(243, 114, 63, 1)", color: "#fff", "&:hover": { backgroundColor: "rgba(243, 114, 63, 1)" } }}>{skill.skill7}</Button>
                    <Button sx={{ width: "115.42px", height: "38.84px", borderRadius: "13.38px", backgroundColor: "rgba(243, 114, 63, 1)", color: "#fff", "&:hover": { backgroundColor: "rgba(243, 114, 63, 1)" } }}>{skill.skill8}</Button>
                    <Button sx={{ width: "115.42px", height: "38.84px", borderRadius: "13.38px", backgroundColor: "rgba(243, 114, 63, 1)", color: "#fff", "&:hover": { backgroundColor: "rgba(243, 114, 63, 1)" } }}>{skill.skill9}</Button>
                    <Button sx={{ width: "115.42px", height: "38.84px", borderRadius: "13.38px", backgroundColor: "rgba(243, 114, 63, 1)", color: "#fff", "&:hover": { backgroundColor: "rgba(243, 114, 63, 1)" } }}>{skill.skill10}</Button>
                </div>
            </div></>
       ))}
        

      {modalOpen && <div id={Styles.ModalContainer} >
        <div id={Styles.Modal}  >
        <label>SKill 1</label>
          <input type="text" value={newWorkSkill.skill1} onChange={(e) => setNewWorkSkill({ ...newWorkSkill, skill1: e.target.value })} />
          <label>SKill 2</label>
          <input type="text" value={newWorkSkill.skill2} onChange={(e) => setNewWorkSkill({ ...newWorkSkill, skill2: e.target.value })} />
          <label>Skill 3</label>
          <input type="text" value={newWorkSkill.skill3} onChange={(e) => setNewWorkSkill({ ...newWorkSkill, skill3: e.target.value })} />
          <label>Skill 4</label>
          <input type="text" value={newWorkSkill.skill4} onChange={(e) => setNewWorkSkill({ ...newWorkSkill, skill4: e.target.value })} />
          <button onClick={handleAddWorkSkill} className={Styles.btn1}>Add</button>
            <button onClick={handleCloseModal} className={Styles.btn2}>close</button>
        </div>
        </div>}
            </div>
    );
  }
export default SKills;